import {
  CustomerCreationResponseDto,
  CustomerPropertiesDto,
  CustomerStatusDto,
  CustomerTypeDto,
} from '@/api/generated';

type CreateParams = {
  create: () => Promise<CustomerCreationResponseDto>;
  dto: CustomerCreateRequest;
  onPostCreateAction?: (customer: CustomerPropertiesDto) => void;
  openDetails: (customerId: number) => void;
  type: CustomerTypeDto;
};

/** The create request of any customer type; the status is absent when the creator cannot choose it. */
type CustomerCreateRequest = Omit<CustomerPropertiesDto, 'customerId' | 'status' | 'type'> & {
  status?: CustomerStatusDto;
};

type UpdateParams = {
  customerId: number;
  openDetails: (customerId: number) => void;
  update: () => Promise<void>;
};

/**
 * The submit of the business, foreign and individual customer forms. A refused save is reported by the
 * toast of its mutation (see `useCustomerMutationOptions`) and leaves the form as it is.
 */
export const customerFormSubmitUtil = {
  /**
   * Creates the customer, then hands it to `onPostCreateAction` with the status the backend gave it
   * (Prospekt unless the creator chose another) or opens its details.
   */
  create: async ({ create, dto, onPostCreateAction, openDetails, type }: CreateParams) => {
    const res = await create().catch(() => undefined);
    if (!res) {
      return;
    }
    if (onPostCreateAction) {
      onPostCreateAction({
        ...dto,
        customerId: res.customerId,
        status: dto.status ?? CustomerStatusDto.Prospect,
        type,
      });
      return;
    }
    openDetails(res.customerId);
  },
  /** Updates the customer, then opens its details. */
  update: async ({ customerId, openDetails, update }: UpdateParams) => {
    const isUpdated = await update().then(
      () => true,
      () => false,
    );
    if (isUpdated) {
      openDetails(customerId);
    }
  },
};
